/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_Tools_All_LabelInputs */

const en_common_header_tools_all_label = /** @type {(inputs: Common_Header_Tools_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All AI tools`)
};

const zh_common_header_tools_all_label = /** @type {(inputs: Common_Header_Tools_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部 AI 工具`)
};

/**
* | output |
* | --- |
* | "All AI tools" |
*
* @param {Common_Header_Tools_All_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_tools_all_label = /** @type {((inputs?: Common_Header_Tools_All_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_Tools_All_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_tools_all_label(inputs)
	return zh_common_header_tools_all_label(inputs)
});
export { common_header_tools_all_label as "common.header.tools.all.label" }